"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/project/delete");
//#region INITIAL STATE
exports.initialState = {
    isOpen: false,
    project: undefined,
    status: 'INITIAL'
};
//#endregion
//#region LENS
const isOpenLens = monocle.Lens.fromProp('isOpen');
const projectLens = monocle.Lens.fromProp('project');
const statusLens = monocle.Lens.fromProp('status');
//#endregion
//#region METHODS
exports.methods = {};
exports.methods[ActionTypes.TOGGLE_DELETE_MODAL] = (state, action) => {
    if (isOpenLens.get(state)) {
        return Object.assign({}, exports.initialState);
    }
    return fp.function.compose(projectLens.set(action.payload), isOpenLens.modify((isOpen) => !isOpen), statusLens.set('INITIAL'))(state);
};
exports.methods[ActionTypes.DELETE_PROJECT_REQUEST] = (state) => statusLens.set('DELETING')(state);
exports.methods[ActionTypes.DELETE_PROJECT_SUCCESS] = (state, action) => statusLens.set('DELETED')(state);
exports.methods[ActionTypes.DELETE_PROJECT_FAILURE] = (state) => statusLens.set('FAILED')(state);
//#endregion
const reducer = (state, action) => exports.methods[action.type](state, action);
exports.reducer = reducer;
//# sourceMappingURL=delete.js.map